module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex flex-row py-2 border-bottom-medium"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-grow-1 leftArea"
  }, [_c('div', {
    staticClass: "fs-larger font-weight-600 darker"
  }, [_vm._v(_vm._s(_vm.ticketLabel)), (!_vm.hideCounter) ? _c('span', [_vm._v(":")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller dark"
  }, [_vm._v(_vm._s(_vm.ticketPrice))])]), _vm._v(" "), (!_vm.hideCounter) ? _c('div', {
    staticClass: "rightArea"
  }, [(!_vm.disabled) ? _c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.changePax('subtract', _vm.personPrice)
      }
    }
  }, [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.personPrice.quantityToBook),
      expression: "personPrice.quantityToBook",
      modifiers: {
        "number": true
      }
    }, {
      name: "numInt",
      rawName: "v-numInt"
    }],
    staticClass: "text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-1",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "value": "0"
    },
    domProps: {
      "value": (_vm.personPrice.quantityToBook)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.personPrice, "quantityToBook", _vm._n($event.target.value))
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
        return _vm.paxManuallyChanged(_vm.personPrice)
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.disabled) ? _c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.changePax('add', _vm.personPrice)
      }
    }
  }, [_vm._v(" + ")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-32372df3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32372df3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabReservation/reservationTicketPrice.vue
// module id = 1843
// module chunks = 0